export const PermissionColor = {
    PUT: "mgr-colors-**-PUT",
    POST: "mgr-colors-POST",
    DELETE: "mgr-colors-**-DELETE",
    GET: "mgr-colors-search-**-GET",
    GET_UUID: "mgr-colors-**-GET"
};